import { actionTypes } from './actions';
import { initialState } from './initial';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };

    case actionTypes.GET_STATISTIC_PROVIDER:
      return {
        ...state,
        statisticProvider: { ...action.payload },
        actionProcessing: false,
      };

    default:
      return state;
  }
}
